var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngageIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 120,
    viewBox: "0 0 156 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_90763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.692 87.6257C142.692 87.6257 141.089 120 88.2943 120C44.5781 120 28.2983 100.434 28.2983 60.6404C28.2983 20.8472 51.4574 6.0415 88.2943 6.0415C125.131 6.0415 140.589 25.8415 145.616 39.5355C147.678 45.0051 148.202 54.615 148.266 56.4678C148.331 58.3205 155.049 87.8432 155.049 87.8432L142.7 87.6338L142.692 87.6257Z",
    fill: "#B245FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6195 9.19917L32.9623 10.9955L42.524 30.3685L55.7347 32.2857L46.1731 41.6057L48.4285 54.76L36.6195 48.5494L24.8023 54.76L27.0578 41.6057L17.4961 32.2857L30.7069 30.3685L40.2685 10.9955L36.6195 9.19917L32.9623 10.9955L36.6195 9.19917L32.9623 7.39478L25.3017 22.9254L0 26.5986L18.3097 44.4492L13.984 69.6462L36.6195 57.7485L59.2468 69.6462L54.9211 44.4492L73.2309 26.5986L47.9291 22.9254L36.6195 0L32.9623 7.39478L36.6195 9.19917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.732 86.9731C128.732 95.9951 121.418 103.301 112.404 103.301C103.39 103.301 96.0757 95.987 96.0757 86.9731",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_90763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.041,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngageIcon1);
export default __webpack_public_path__ + "static/media/engageIcon1.5b770687d66180a19c5d2da12e0e190c.svg";
export { ForwardRef as ReactComponent };